import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Settings, Star, ChevronDown, ChevronUp, LayoutGrid, List as ListIcon } from 'lucide-react';
import KanbanBoard from './KanbanBoard';
import CandidatoList from './CandidatoList';

const ProcessCard = ({ id, titulo, Cliente, Candidatos = [], onCandidatoClick }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [viewMode, setViewMode] = useState('kanban'); // 'kanban' o 'list'

  // Agrupamos contadores para las estadísticas superiores
  const countByEtapa = (etapa) => Candidatos.filter(c => c.etapa_actual === etapa).length;

  const stats = [
    { label: "Nuevos Postulantes", count: countByEtapa('Nuevos Postulantes') },
    { label: "Hunting", count: countByEtapa('Hunting') },
    { label: "Posibles", count: countByEtapa('Posibles') },
    { label: "Entrevista Consultora", count: countByEtapa('Entrevista Consultora') },
    { label: "Entrevista Psicológica", count: countByEtapa('Entrevista Psicologica') },
    { label: "Terna", count: countByEtapa('Terna') },
    { label: "Contratado", count: countByEtapa('Contratado') },
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 mb-4 overflow-hidden">
      <div 
        className="p-4 flex justify-between items-center bg-white border-b border-gray-50 cursor-pointer group"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-2">
          <Star size={18} className="text-emeral-green" />
          <Link to={`/procesos/${id}`} onClick={(e) => e.stopPropagation()}>
            <h3 className="text-lg font-semibold text-emeral-green hover:underline transition">
              {titulo}
            </h3>
          </Link>
          <span className="text-sm text-gray-400 ml-2">{Cliente ? Cliente.nombre : 'Sin Cliente'}</span>
        </div>
        <div className="flex items-center gap-4">
          <Settings size={18} className="text-gray-400 hover:text-gray-600" onClick={(e) => e.stopPropagation()} />
          {isExpanded ? <ChevronUp size={20} className="text-gray-400" /> : <ChevronDown size={20} className="text-gray-400" />}
        </div>
      </div>
      
      <div className="grid grid-cols-7 divide-x divide-gray-100 text-center py-6">
        {stats.map((stat, index) => (
          <div key={index} className="flex flex-col">
            <span className={`text-xl font-bold ${stat.count > 0 ? 'text-red-500' : 'text-gray-300'}`}>
              {stat.count || '-'}
            </span>
            <span className="text-[10px] uppercase font-medium text-gray-500 mt-1">
              {stat.label}
            </span>
          </div>
        ))}
      </div>

      {isExpanded && (
        <div className="border-t border-gray-100 bg-gray-50 pb-4">
          <div className="flex justify-between items-center px-4 pt-4">
            <h4 className="text-sm font-bold text-gray-600 uppercase">Candidatos en Proceso</h4>
            <div className="flex items-center gap-1 bg-white border rounded p-1">
              <button 
                onClick={(e) => { e.stopPropagation(); setViewMode('kanban'); }}
                className={`p-1 rounded flex items-center justify-center ${viewMode === 'kanban' ? 'bg-emeral-green text-white' : 'text-gray-400 hover:bg-gray-100'}`}
                title="Vista Kanban"
              >
                <LayoutGrid size={14} />
              </button>
              <button 
                onClick={(e) => { e.stopPropagation(); setViewMode('list'); }}
                className={`p-1 rounded flex items-center justify-center ${viewMode === 'list' ? 'bg-emeral-green text-white' : 'text-gray-400 hover:bg-gray-100'}`}
                title="Lista Detallada"
              >
                <ListIcon size={14} />
              </button>
            </div>
          </div>
          
          {viewMode === 'kanban' ? (
            <KanbanBoard candidatos={Candidatos} onCandidatoClick={onCandidatoClick} />
          ) : (
            <CandidatoList candidatos={Candidatos} onCandidatoClick={onCandidatoClick} />
          )}
        </div>
      )}

      <div className="bg-gray-50 px-4 py-2 text-[10px] text-gray-400 flex justify-end uppercase border-t border-gray-100">
        Click en la cabecera para {isExpanded ? 'contraer' : 'expandir'}
      </div>
    </div>
  );
};

export default ProcessCard;